import { Favorite, FavoriteBorder } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { useTheme } from '@mui/material/styles'
import React from 'react'

export interface FavoriteButtonProps {
    count: number
    onClick: (isSelected: boolean) => void
    disabled?: boolean
    isSelected?: boolean
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({
    count = 0,
    onClick,
    disabled = false,
    isSelected = false,
}) => {
    const [isSelectedState, setIsSelectedState] = React.useState(isSelected)
    const [countState, setCountState] = React.useState(count)

    const handleClick = () => {
        const newState = !isSelectedState
        if (newState) {
            setCountState(countState + 1)
        } else {
            setCountState(Math.max(countState - 1, 0))
        }
        setIsSelectedState(newState)
        onClick(newState)
    }
    const theme = useTheme()
    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <IconButton
                aria-label="Favorite"
                onClick={handleClick}
                size="medium"
                disabled={disabled}
            >
                <Box
                    position="relative"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    {isSelectedState ? (
                        <Favorite color="error" />
                    ) : (
                        <FavoriteBorder />
                    )}
                    {countState > 0 && (
                        <Typography
                            variant="caption"
                            position="absolute"
                            fontWeight="bold"
                            color={
                                isSelectedState
                                    ? theme.palette.common.white
                                    : theme.palette.action.active
                            }
                        >
                            {countState}
                        </Typography>
                    )}
                </Box>
            </IconButton>
        </Box>
    )
}

export default FavoriteButton
